import React, { useEffect, useState } from 'react';
import ENDPOINT from '../../../globals/api-endpoint';
import styled from 'styled-components';
import media from 'styled-media-query';
import NumberFormat from 'react-number-format';
import { NavLink } from 'react-router-dom';

const ProjectListStyled = styled.div`
	margin-top: 20px;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 10px;
	${media.lessThan('small')`
		grid-gap: 20px;
		grid-template-columns: 1fr;
	`}
	${media.between('small', 'medium')`
		grid-gap: 20px;
		grid-template-columns: 1fr 1fr;
	`}
`;

const ProjectOne = styled.div`
	border-radius: 5px;
	padding: 15px;
	transition: all 0.5s;
	&:hover {
		-webkit-box-shadow: 0px 1px 3px 0px rgba(140,140,140,1);
		-moz-box-shadow: 0px 1px 3px 0px rgba(140,140,140,1);
		box-shadow: 0px 1px 3px 0px rgba(140,140,140,1);
	}
	${props => {
		if(!props.ClosedStyled){
			return `border: 1px solid ${props.theme.green};`;
		} else {
			return `border: 1px solid red;`;
		}
	}}
`;

const Title = styled.h4`
	margin-bottom: 5px;
	border-bottom: 1px solid gray;
	padding-bottom: 5px;
	color: black;
`;

const P = styled.p`
	font-size: 12px;
	margin-bottom: 5px;
	color: black;
`;

const H3 = styled.h3`
	text-align: center;
	margin: 10px;
	padding: 10px;
	color: black;
`;

const Button = styled.button`
	background: ${props => props.theme.green};
	padding: 5px;
	font-family: 'Catamaran', sans-serif;
	border-radius: 5px;
	border: 2px solid ${props => props.theme.green};
	color: white;
	transition: all 0.5s;
	&:hover {
		color: ${props => props.theme.green};
		background: white;
		cursor: pointer;
	}
`;

const Project = (props) => {
	const [isLoading, setIsloading] = useState(null);
	const [isFailed, setIsFailed] = useState(null);
	const [token, setToken] = useState({
		authToken: localStorage.getItem('authToken')
	});
	const [projects, setProjects] = useState([]);

	const localToken = JSON.parse(token.authToken);
	const tokenFromStorage = localToken ? (localToken.token) : (null);

	useEffect(() => {
		setToken({
			authToken: localStorage.getItem('authToken')
		});
	}, []);

	useEffect(() => {
		const fetchData = () => { 
			setIsloading(true);
			fetch(ENDPOINT.MY_PROJECTS, {
				headers: {
					authorization: tokenFromStorage
				}
			})
			.then(res => res.json())
			.then(res => {
				setProjects(res.projects)
				setIsFailed(false);
			})
			.catch(err => {
				console.log(err);
				setIsFailed(true);
			})
			.finally(res => {
				setIsloading(false)
			});
		}
		if (projects.length < 1) {
			fetchData();
		}
	}, [tokenFromStorage, projects.length]);

	const loading = 
		<div className="loading">
			<div className="sk-folding-cube">
			  <div className="sk-cube1 sk-cube"></div>
			  <div className="sk-cube2 sk-cube"></div>
			  <div className="sk-cube4 sk-cube"></div>
			  <div className="sk-cube3 sk-cube"></div>
			</div>
		</div>

	const failed = isFailed ? (
		<div className="failed">failed</div>
	) : (null);

	const Description = (project) => {
		if(project.description.length > 50) {
			return project.description.slice(0, 50);
		} else {
			return project.description;
		}
	}

	const [isDeleted, setIsDeleted] = useState(null);

	const getAllProjects = () => { 
		setIsloading(true);
		fetch(ENDPOINT.MY_PROJECTS, {
			headers: {
				authorization: tokenFromStorage
			}
		})
		.then(res => res.json())
		.then(res => {
			setProjects(res.projects)
			setIsFailed(false);
		})
		.catch(err => {
			console.log(err);
			setIsFailed(true);
		})
		.finally(res => {
			setIsloading(false)
		});
	}

	const handleDeleteButton = (id) => {
		setIsloading(true);
		fetch(ENDPOINT.ALL_PROJECTS + '/' + id, {
			method: 'DELETE',
			headers: {
				authorization : tokenFromStorage
			}
		})
		.then(res => res.json())
		.then(res => {
			setIsDeleted(true);
			getAllProjects()
		})
		.catch(err => {
			console.log(err);
			setIsDeleted(false);
		})
		.finally(res => {
			setIsloading(false);
		})
	}

	const ProjectList = projects.map(project => {
		return(
			<ProjectOne ClosedStyled={project.closed} key={project._id}>
				<NavLink to={'/proyek/' + project._id}>
					<Title>{project.name}</Title>
				</NavLink>
				<P><NumberFormat value={project.price} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} /></P>
				<P>{project.user.name}</P>
				<P>{ Description(project) }</P>
				<Button onClick={() => {handleDeleteButton(project._id)}}>Hapus</Button>
			</ProjectOne>
		);
	})

	const DeleteView = () => {
		if (isDeleted === true) {
			return <p>Proyek berhasil dihapus</p>
		} else if (isDeleted === false) {
			return <p>Proyek gagal dihapus</p>
		} else {
			return null
		}
	}

	return(
		<div className="project__list">
			<H3>Daftar Proyek Saya</H3>
			<DeleteView />
			{ failed }
			{ isLoading ? (loading) : ( projects.length > 0 ? (<ProjectListStyled>
				{ ProjectList }
			</ProjectListStyled>) : (<p>Anda belum membuat proyek apapun</p>) ) }
		</div>
	);
}

export default Project;